export const getAttributeInfo = attributes => {
    return {
        customizationOptions: attributes?.customizable?.[0]?.text,
        isResizable: attributes?.ringResizable?.[0]?.value === 'Yes',
    };
};
